import { AppointmentState } from '@uplift/types';
import { restClient } from '../../client';
import { AppointmentRecurring } from '../../resources';


export type PublicAppointment = {
  timezone: string;
  fromDatetime: string;
  toDatetime: string;
  recurring: AppointmentRecurring;
  state?: AppointmentState;
};


export type PatientCheckInviteTokenOutput = {
  matchId: string;
  patient: {
    id: string;
    email: string;
  };
  appointment?: PublicAppointment;
  providerId: string;
  error?: string;
};

export const patientCheckInviteToken = (inviteToken: string) => restClient.request<PatientCheckInviteTokenOutput>('/auth/check_invite_link', {
  method: 'POST',
  data: { invite_token: inviteToken },
});


export enum BetterhelpReferralType {
  EAP = 'EAP',
  BH40 = 'BH40',
}

export type BetterhelpInviteTokenDetails = {
  userId: string;
  referralUuid: string;
  eapUuid: string;
  memberUuid: string | null;
  referralType: BetterhelpReferralType;
  eapName: string;
  accessCodeName: string | null;
  sessionCount: number;
  email: string;
  memberFirstName: string;
  memberLastName: string;
  inviteToken: string | null;
};

export const getBetterhelpReferralDetailsByInviteToken = async (token: string) => {
  return restClient.request<{
    data: BetterhelpInviteTokenDetails;
  }>('/api/v1/betterhelp/invite/by_token', {
    method: 'POST',
    data: { invite_token: token },
  });
};


export const getBetterhelpReferralDetails = async () => {
  return restClient.request<{
    data: BetterhelpInviteTokenDetails;
  }>('/api/v1/betterhelp/invite/details');
};

export const getBetterhelpReferralDetailsForAdmin = async (userId: string) => {
  return restClient.request<{
    data: BetterhelpInviteTokenDetails;
  }>(`/api/v1/admin/patient/${userId}/betterhelp_referral`);
};


export const getBetterhelpMemberDetails = async (userId: string) => {
  return restClient.request<{
    data: {
      id: string;
      userId: string;
      memberUuid: string;
      portalUuid: string;
      createdAt: string;
      updatedAt: string;
    };
  }>(`/api/v1/admin/patient/${userId}/betterhelp/member`);
};
